import LiquidationRequest from '@/services/liquidation_request'

const save = async (context, payload) => {
  return new Promise((resolve, reject) => {
    LiquidationRequest.save(payload).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}

const fetchInvoicesSelectedAdmin = async ({ commit }, payload) => {
  return new Promise((resolve, reject) => {
    LiquidationRequest.fetchInvoices(payload).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}

const exportCnabFile = async (context, id) => {
  return new Promise((resolve, reject) => {
    LiquidationRequest.exportCnabFile(id).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}

export default {
  save,
  fetchInvoicesSelectedAdmin,
  exportCnabFile
}



// WEBPACK FOOTER //
// ./src/features/liquidation_requests/store/actions.js